<template>
  <div class="passport-container">
    <div class="logo-container">
      <div class='logo'><a href="/"><img src="../../assets/images/logo.png" height="32px" width="125px"/></a></div>
    </div>
    <div v-if="!sendMobileSuccess" class="passport dialog-form">
      <h1>登录</h1>
      <p class="sm-tip">忘记密码？</p>
      <div class="error-tip-container">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
      </div>
      <p class="sm-tip" v-if="sendEmailSuccess">密码重置邮件发送至您的邮箱！请查收并完成下一步操作。</p>
      <div v-if="!sendEmailSuccess">
        <div class="text-center" style="height: 280px;padding-top: 90px;" v-show="loading">
          <Loading type="1"></Loading>
        </div>
        <el-form ref="form" :model="form" :rules="rules" v-if="!loading">
          <el-form-item label="" prop="emailOrMobile">
            <YueDanIpt class="emailOrMobile" model="emailOrMobile" :focus="true" :object="form" placeholder="邮箱/手机"></YueDanIpt>
          </el-form-item>
          <div class="btn-container">
            <el-button type="primary block" @click="submit()" :loading="loading">发送重置请求</el-button>
          </div>
          <div class="footer-container">
            <a class="normal-content" href="/login">取消</a>
            <a class="dialog-content" @click="showLoginDialog()">取消</a>
          </div>
        </el-form>
      </div>
    </div>
    <ResetPwdByMobile :class="{'passport-dialog':isDialog}" v-if="sendMobileSuccess" :mobile="form.emailOrMobile"></ResetPwdByMobile>
  </div>
</template>

<script>
import api from '../../services/api.js'
import YueDanIpt from '../../components/YueDanIpt'
import Loading from '../../components/Loading'
import ResetPwdByMobile from './ResetPwdByMobile'

let $ = require('jQuery')

export default {
  name: 'ForgetPwd',
  props: ['isDialog'],
  components: {
    YueDanIpt: YueDanIpt,
    Loading: Loading,
    ResetPwdByMobile: ResetPwdByMobile
  },
  data () {
    var checkExist = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱/手机是必填项'));
      }
      if (!/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value) && !/^1[3456789]\d{9}$/.test(value)) {
        return callback(new Error('必须输入有效的电子邮件地址或手机号'))
      }
      let apiPath
      let err;
      if (/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
        apiPath = 'check_email_exist'
        delete this.form.mobile
        this.form.email = this.form.emailOrMobile
        err = '此邮箱尚未注册，请前去注册'
      } else {
        apiPath = 'check_mobile_exist'
        delete this.form.email
        this.form.mobile = this.form.emailOrMobile
        err = '此手机尚未注册，请前去注册'
      }
      api.post(this, {
        path: 'passport.php',
        data: this.form,
        api: apiPath
      }).then((res) => {
        if (res.body.result === true) {
          callback();
        } else{
          callback(new Error(err));
        }
      }, err => {

      })
    }
    return {
      form: {
        emailOrMobile: ''
      },
      loading: false,
      errors: null,
      isEmptyErrors: true,
      sendEmailSuccess: null,
      sendMobileSuccess: false,
      rules: {
        emailOrMobile: [
          { validator: checkExist, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submit: function () {
      this.$refs['form'].validate((valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (valid) {
          api.post(this, {
            path: 'passport.php',
            data: this.form,
            loading: 'loading',
            api: this.form.email ? 'init_reset_password' : 'forget_password_send_sms'
          }).then((res) => {
            if (res.body.status === 'ok') {
              if (this.form.email) {
                this.sendEmailSuccess = true
              } else {
                this.sendMobileSuccess = true
              }
              // this.dialogFormVisible = false
              // this.$emit('success')
            }
          }, err => {

          })
        } else {
          return false;
        }
      })
    },
    showLoginDialog () {
      this.$store.commit('showGlobalDialog', 'loginVisible')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/passport/ForgetPwd.vue